import React from "react";
import "./Header.css";

const Header = ({ missionTime, onMenuClick, onTerminalClick }) => {
  return (
    <header className="header">
      <div className="header-left">
        <button className="mobile-menu-btn" onClick={onMenuClick}>
          ☰
        </button>
        <div className="operation-box">
          <div className="operation-title">PHOENIX CYBERSECURITY</div>
          <div className="operation-subtitle">ENCIPHERX 4.0</div>
        </div>
      </div>

      <div className="header-center">
        <div className="mission-eta">
          <span className="eta-label">//MISSION DATE</span>
          <div className="eta-date">February 7-8, 2026</div>
          <div className="eta-timer">{missionTime}</div>
        </div>
      </div>

      <div className="header-right">
        <button className="header-button" onClick={onTerminalClick}>
          [ACCESS CONSOLE]
        </button>
        <button className="header-button">[JOIN OPERATION]</button>
      </div>
    </header>
  );
};

export default Header;
